import { jtbdDismissInfo } from '@fiverr-private/jtbd_sdk';
import { JTBDOrder } from '../../types/order';
import { Order } from '../../types/gqlTypes';
import { Notification } from '../../types/notifications';
import { buildOrdersData } from './buildOrdersData';
import { selectOrderUnreadNotification } from './selectOrderUnreadNotification';
import { selectOrderToDisplay } from './selectOrderToDisplay';

export const getRelevantOrder = (
    responses: [Order[], Notification[]],
    jtbdDismissInfo?: jtbdDismissInfo
): JTBDOrder | undefined => {
    const [orders, userNotifications] = responses;
    const { ordersByEncryptedId, deliveredOrder } = buildOrdersData(orders);
    const selectedOrderUnreadNotification = selectOrderUnreadNotification(
        userNotifications,
        ordersByEncryptedId,
        deliveredOrder,
        jtbdDismissInfo
    );

    return selectOrderToDisplay({
        ordersByEncryptedId,
        selectedOrderUnreadNotification,
    });
};
